/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Your_Identity_BrandinInputs */

const en_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control your identity, branding, and monetization engine.`)
};

const es_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controla tu identidad, marca y motor de monetización.`)
};

const fr_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrôlez votre identité, votre image de marque et votre moteur de monétisation.`)
};

const de_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrolliere deine Identität, dein Branding und deine Monetarisierung.`)
};

const ja_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのアイデンティティ、ブランディング、収益化エンジンをコントロールします。`)
};

const zh_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`控制您的数字身份、品牌建设和变现引擎。`)
};

const ar_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحكم في هويتك وعلامتك التجارية ومحرك تحقيق الدخل.`)
};

const id_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrol identitas, branding, dan mesin monetisasi Anda.`)
};

const it_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla la tua identità, il tuo branding e il tuo motore di monetizzazione.`)
};

const ru_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контролируйте свою идентичность, бренд и систему монетизации.`)
};

const pt_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle sua identidade, branding e mecanismo de monetização.`)
};

const ko_control_your_identity_brandin = /** @type {(inputs: Control_Your_Identity_BrandinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이덴티티, 브랜딩, 수익화 엔진을 제어하세요.`)
};

/**
* | output |
* | --- |
* | "Control your identity, branding, and monetization engine." |
*
* @param {Control_Your_Identity_BrandinInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const control_your_identity_brandin = /** @type {((inputs?: Control_Your_Identity_BrandinInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Your_Identity_BrandinInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_your_identity_brandin(inputs)
	if (locale === "es") return es_control_your_identity_brandin(inputs)
	if (locale === "fr") return fr_control_your_identity_brandin(inputs)
	if (locale === "de") return de_control_your_identity_brandin(inputs)
	if (locale === "ja") return ja_control_your_identity_brandin(inputs)
	if (locale === "zh") return zh_control_your_identity_brandin(inputs)
	if (locale === "ar") return ar_control_your_identity_brandin(inputs)
	if (locale === "id") return id_control_your_identity_brandin(inputs)
	if (locale === "it") return it_control_your_identity_brandin(inputs)
	if (locale === "ru") return ru_control_your_identity_brandin(inputs)
	if (locale === "pt") return pt_control_your_identity_brandin(inputs)
	return ko_control_your_identity_brandin(inputs)
});